import "./edit-recipient.scss";
export const EditRecipientsButton = () => (
  <div className="edit-recipient_container">
    <i className="ri-edit-2-line edit-recipient_icon"></i>{" "}
    <p className="edit-recipient_text">Edit Recipients</p>
  </div>
);
